module.exports = __webpack_public_path__ + "img/00_banner_1200px_120px.d7457b1c.png";